import OrderFeeDetails from './OrderFeeDetails/OrderFeeDetails'
import OrderItemCertificates from './OrderItemCertificates/OrderItemCertificates'
import OrderItemDetails from './OrderItemDetails/OrderItemDetails'
import OrderItemFeeCertificates from './OrderItemFeeCertificates/OrderItemFeeCertificates'
import OrderItemImage from './OrderItemImage/OrderItemImage'
import OrderProjectDetails from './OrderProjectDetails/OrderProjectDetails'

export const content = {
  OrderItemDetails,
  OrderItemImage,
  OrderProjectDetails,
  OrderFeeDetails,
  OrderItemCertificates,
  OrderItemFeeCertificates
}
